export default __webpack_public_path__ + "c42c25e897612244880d444a7a76b0d4.png";